export enum DevelopmentPlanStatus {
  Planned = 10,
  InProgress = 20,
  Completed = 30
}
